const cache: any = {};

/**
 * padString pads string with N number of characters in front of the supplied value
 * @param padding
 * @param char
 * @param value
 * @return {string} Padded string
 */
export function padString(length: number, char: string, value: string) {
    let k = length.toString() + char + value;
    if (!cache[k]) {
        let s = value || "";
        while (s.length < length) {
            s = char + s;
        }
        cache[k] = s;
    }
    return cache[k];
}

export const padTime = padString.bind(undefined, 2, "0");


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./helpers/PadString/PadString.ts